import { createRoot, StrictMode } from "@wordpress/element";

import App from "./App";

document.addEventListener("DOMContentLoaded", () => {
  const el = document.getElementById("recherche-salle");
  const root = createRoot(el);
  root.render(
    <StrictMode>
      <App {...el.dataset} />
    </StrictMode>
  );
});
